module.exports = __webpack_public_path__ + "img/History.2ca5ec46.svg";